import React, { useState, useEffect } from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const NotificationManager = () => {
    const { t } = useTranslation();
    const [permission, setPermission] = useState('default');

    useEffect(() => {
        if ('Notification' in window) {
            setPermission(Notification.permission);
        }
    }, []);

    useEffect(() => {
        // This component doesn't need to do anything on mount for now
    }, []);

    const requestPermission = async () => {
        if (!('Notification' in window)) {
            alert(t('notificationManager.notSupported'));
            return;
        }

        const result = await Notification.requestPermission();
        setPermission(result);

        if (result === 'granted') {
            // In a real implementation, you would get the FCM token here
            // and save it to the server for this user.
            console.log('Notification permission granted.');
            // new Notification('Awesome!', { body: 'You will now receive updates from the DreamWeave.' });
        }
    };

    if (permission === 'granted') {
        return (
            <div className="flex items-center text-xs text-green-400">
                <LucideIcons.BellRing size={14} className="mr-1" />
                <span>{t('notificationManager.enabled')}</span>
            </div>
        );
    }

    return (
        <button 
            onClick={requestPermission}
            className="flex items-center text-xs text-yellow-400 hover:text-yellow-300"
        >
            <LucideIcons.Bell size={14} className="mr-1" />
            <span>{t('notificationManager.enable')}</span>
        </button>
    );
};

export default NotificationManager;
